import React from 'react';
import { Upload } from 'lucide-react';
import { toast } from 'react-toastify';
import { CustomModal } from '../../common/CustomModal';
import i18n from '../../../i18n';
import { UploadClientApprovalDoc } from '../../../models/auctions';

export class UploadClientDocModal extends React.Component {
  constructor() {
    super();
    this.state = {
      submitting: false,
      selectedFile: null,
      fileError: '',
    };
  }

  handleClose = () => {
    this.setState({
      submitting: false,
      selectedFile: null,
      fileError: '',
    });
    this.props.onClose();
  };

  handleFileChange = (e) => {
    const file = e.target.files[0];

    this.setState({
      selectedFile: file,
      fileError: file ? '' : 'File is required',
    });
  };

  handleUpload = async () => {
    const { selectedRow } = this.props;
    const { selectedFile } = this.state;

    if (!selectedFile) {
      this.setState({ fileError: 'Please select a document file' });
      return;
    }

    try {
      this.setState({ submitting: true });

      const formData = new FormData();
      formData.append('file', selectedFile);
      formData.append('enroll_id', selectedRow.id);

      const response = await UploadClientApprovalDoc(formData);

      if (response.success) {
        toast.success(response.message || 'File uploaded and approved successfully');
        this.handleClose();
      } else {
        toast.error(response.message || 'Failed to upload file');
      }
    } catch (error) {
      console.error(error);
      toast.error('Something went wrong');
    } finally {
      this.setState({ submitting: false });
    }
  };

  render() {
    const { show, selectedRow } = this.props;
    const { submitting, selectedFile, fileError } = this.state;

    if (!selectedRow) return null;

    return (
      <CustomModal
        isOpen={show}
        header={i18n.t('Upload Client Document')}
        onClose={this.handleClose}
      >
        <div className="action-modal-container">
          {/* Info Section */}
          <div className="payment-details-card">
            <h6>{i18n.t('Client Information')}</h6>

            <div className="details-grid">
              <div className="detail-item-new">
                <span className="detail-label">Auction ID</span>
                <span className="detail-value">MZAD {selectedRow.auction_id}</span>
              </div>

              <div className="detail-item-new">
                <span className="detail-label">Client Enrollment</span>
                <span className="detail-value success">
                  {selectedRow.group?.is_client_enrollment ? 'Enabled' : 'Disabled'}
                </span>
              </div>
            </div>
          </div>

          {/* File Upload Section */}
          <div className="reject-section">
            <label className="reject-label">
              {i18n.t('Choose Document')} <span className="required">*</span>
            </label>

            <input
              type="file"
              accept="application/pdf,image/*"
              onChange={this.handleFileChange}
              className={`reject-textarea ${fileError ? 'error' : ''}`}
              disabled={submitting}
            />

            {fileError && <span className="error-message">{fileError}</span>}
            {selectedFile && <span className="selected-file">{selectedFile.name}</span>}
          </div>

          {/* Action Buttons */}
          <div className="action-buttons-container">
            <button
              className="modal-btn btn-cancel"
              onClick={this.handleClose}
              disabled={submitting}
            >
              {i18n.t('Cancel')}
            </button>

            <button
              className="modal-btn btn-confirm"
              onClick={this.handleUpload}
              disabled={submitting}
            >
              <Upload size={18} />
              {submitting ? i18n.t('Uploading...') : i18n.t('Upload File')}
            </button>
          </div>
        </div>
      </CustomModal>
    );
  }
}
